﻿import { Component,OnInit, EventEmitter, Output,ViewChild,ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { Department } from "../../models/department.model";
import { DataService } from "../../services/dataService";
import { ValidationBase } from "../../validation/validationBase";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";
import { EmailValidator } from "../../validation/validators/emailValidator";
import { ValidatorTuple } from "../../validation/validators/iValidator";
import { EmployeeIdValidator } from "./employeeIdSSNValidator";
import { PhoneValidator } from "../../validation/validators/phoneValidator";
import { UpperCasePipe } from "@angular/common/src/pipes/case_conversion_pipes";


@Component({
    selector: "jax-signup",
    templateUrl: ".//signup.component.html",
})

export class SignupComponent  extends ValidationBase  {
    public user: any = {};
    public deptDisabled: boolean;
    public iNotifyError;
    public emailValidators = [];
    public employeeIdValidator = [];
    public ssnValidator = [];
    public departmentValidators = [];
    public phoneValidators = [];
    public caseNumberValidator = [];
    
    public departments: Department[] = [];
    
   
    public  validationMessage: ValidationMessage;
    public  departmentValidationMessage: ValidationMessage;
    public  hasSuccess: boolean;
    public IsProcessing: boolean;
    public checkBoxState: boolean;
    public IsPrivateAttorney: boolean=false;
    public IsTermsAccepted:boolean=false;

    @ViewChild('closeModal') closeModal: ElementRef;

    constructor(private dataService: DataService, private router: Router, private sanitizer: DomSanitizer) {
        super();
        this.emailValidators.push(new ValidatorTuple(new EmailValidator(), this));
        this.employeeIdValidator.push(new ValidatorTuple(new EmployeeIdValidator(), this));
        this.ssnValidator.push(new ValidatorTuple(new EmployeeIdValidator(), this));
        this.phoneValidators.push(new ValidatorTuple(new PhoneValidator(), this));
        this.iNotifyError = this;
        this.GetDepartment();
    }

    public ngAfterContentInit() {
        this.IsPrivateAttorney=false;
        this.IsTermsAccepted=false;
    }

    public onCountyChange(e) {
        if ((e != null) && (e.value != "Maricopa County")) {
            let dcsDCSDepartment = this.departments.filter(d => d.value == "DES/CPS");
            if (dcsDCSDepartment.length == 1) {
                this.user.department = dcsDCSDepartment[0]
                this.deptDisabled = true;
            }

        }
        else {
            this.deptDisabled = false;
        }
    }
    public handleChange(e) {
      //  alert("inside hadle");
        if (e.target.checked) {
            let dcsDepartment = this.departments.filter(d => d.value == "DES/CPS");
            if (dcsDepartment.length==1){
            this.user.department = dcsDepartment[0]
            }

        }
        else {
            this.departments = this.departments;
            this.user.department = "";
        }
    }
    public signUp() {
        this.IsProcessing = true;
        this.validateDepartment(this);
        this.validate()
            .subscribe(( s ) => {
                if (!this.isValid || !this.validateDepartment(this) || !this.IsValidDCSDepartmentAndEmail())
                {
                    this.IsProcessing = false;
                    return;
                }

                this.validationMessage = null;
                let message = new ValidationMessage();

                message.message =
                    "<span style=\'font-weight:bold\'>Your registration is <span style=\'color: red !important;\'>NOT</span> complete.</span>" +
                    "<br/><br/><ul><li>Before your new account can be created, we must verify that you are the owner of the email address you supplied.</li>" +
                    "<li>An email has been sent to your inbox, but will <b>expire in 4 hours</b>.</li>" +
                    "<li>You <b>must click the link in that email</b> to continue the account creation process.</li>" +
                    "<li>If you did not receive the email, be sure to check your spam/junk email folders.</li></ul>";


                if (this.user.department != null) {
                    this.user.departmentId = this.user.department.id || this.user.department;
                    this.user.departmentName = this.user.department.value;
                }

                this.phoneFormat();
                if (this.IsDCSUser()) {
                    //call web api for dcs users
                    this.dataService.post("dcsuser/register", JSON.stringify(this.user))
                        .subscribe((response) => {
                                if (response.Succeeded == 2) {
                                    this.hasSuccess = true;
                                    message.messageType = ValidationMessageType.Ok;
                                } else {
                                    this.hasSuccess = false;
                                    message.messageType = ValidationMessageType.Error;
                                    message.message = response.Message;
                                }
                                this.validationMessage = message;
                                this.IsProcessing = false;
                            },
                            error => {
                                this.hasSuccess = false;
                                message.message = error.message.Message;
                                message.messageType = ValidationMessageType.Error;
                                this.validationMessage = message;
                                this.IsProcessing = false;
                            });
                } else {
                    this.dataService.post("user/register", JSON.stringify(this.user))
                        .subscribe((response) => {
                                if (response.Succeeded == 2) {
                                    this.hasSuccess = true;
                                    message.messageType = ValidationMessageType.Ok;
                                } else {
                                    this.hasSuccess = false;
                                    message.messageType = ValidationMessageType.Error;
                            }
                            if (!this.IsPrivateAttorney || response.Succeeded!=2) {
                                    message.message = response.Message;
                                }
                                this.validationMessage = message;
                                this.IsProcessing = false;
                            },
                            error => {
                                this.hasSuccess = false;
                                message.message = error.message.Message;
                                message.messageType = ValidationMessageType.Error;
                                this.validationMessage = message;
                                this.IsProcessing = false;
                            });
                }
            });

    }

    
    public registeruser(cm:any) {
        cm.click();
        if(this.IsTermsAccepted){
            this.signUp();
        }
        else{
            let message = new ValidationMessage();
            this.hasSuccess = false;
            message.message = "Terms and conditions not accepted.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
        }
    }

    public refresh(){
        this.validationMessage =  new ValidationMessage();
    }

    public onLoginClick() {
        this.router.navigate(["login"]);
    }
    private phoneFormat() {
        if (this.user.phone) {
            if (!isNaN(this.user.phone)) {
                this.user.phone = this.user.phone.substring(0, 3) + "-" + this.user.phone.substring(3, 6) + "-" + this.user.phone.substring(6, 10);
            }
            else {
                this.user.phone = this.user.phone.replace(")-", ") ");
            }
        }
    }
    public validateDepartment($event: any): boolean {
        this.departmentValidationMessage = null;
        if (!this.user.department) {
            this.departmentValidationMessage = this.getErrorMessage("Department is required", "department");
            return false;
        }
        let selectedDepartment = this.user.department.id || this.user.department;
        if (!this.departments.find(d => d.id == selectedDepartment)) {
            this.departmentValidationMessage = this.getErrorMessage("Invalid department", "department");
            this.user.department = null;
            return false;
        }

        this.privateAttorney($event);

        return true;
    }

    public autocompleListFormatter = (data: any) => {
        let html = `<span>${data.value}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }


    private GetDepartment() {
        this.dataService.get("common/departments").subscribe(resp => {
            this.departments = resp;
            this.user.department = "";
        });
    }
   
    private IsValidDCSDepartmentAndEmail() {
        let departmentSelected = this.user.department.id || this.user.department;
        let departmentIDValue=  this.departments.find(d => d.id == departmentSelected)
        let emailId = this.user.emailId;
        let emailDomain = emailId.substring(emailId.indexOf('@') + 1);
        let selectedDepartment = this.user.department.id || this.user.department;
        let department = this.departments.find(d => d.id == selectedDepartment);
        if (this.IsDCSUser()) {
            if ((departmentIDValue.value == 'DES/CPS') && (emailDomain.toUpperCase() == 'AZDCS.GOV'))
            {
                return true;
            }
            else {

                this.validationMessage = this.getErrorMessage("Please use valid email and department combination", "emailId");
                return false;
            }
        }
        else {
            return true;
        }
    }
    private IsDCSUser() {
        let departmentSelected = this.user.department.id || this.user.department;
        let departmentIDValue = this.departments.find(d => d.id == departmentSelected)

        let emailId = this.user.emailId;
        let emailDomain = emailId.substring(emailId.indexOf('@') + 1);
        if ((departmentIDValue.value == "DES/CPS") || (emailDomain.toUpperCase() == 'AZDCS.GOV'))
        {
            return true;
        }
        else
        {
            return false;
        }
    }
    
    private getErrorMessage(message: string, propName: string): ValidationMessage {
        let vm = new ValidationMessage();
        vm.message = message;
        vm.propertyName = propName;
        vm.messageType = ValidationMessageType.Error;
        return vm;
    }

    public textToProperCase(event) {
        if (event) {

            let i = event.indexOf("-");
            let ip = event.indexOf(".");

            if (i >= 0) {
                event = event.replace("-", " ");
            }

            if (ip >= 0) {
                event = event.replace(".", " ");
            }


            let properString = event.length > 0
                ? event.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase()))
                : "";
            if (i > 0) {
                properString = properString.substr(0, i) + properString.substr(i).replace(" ", "-");
            }

            if (ip > 0) {
                properString = properString.substr(0, ip) + properString.substr(ip).replace(" ", ".");
            }

            if (properString.substr(0, 3) === "De ") {
                properString = properString.replace("De ", "de ");
            }
            return properString;
        } else {
            return event;
        }
    }

    public privateAttorney($e:any) {
        let departmentSelected = this.user.department.id || this.user.department;
        let departmentIDValue = this.departments.find(d => d.id == departmentSelected)
        if (departmentIDValue.value == "Private Counsel") {
            this.IsPrivateAttorney= true;

        } else {
            this.IsPrivateAttorney=false;
        }
    }
}
